import { OPEN_MODAL, CLOSE_MODAL } from './constants';

/**
 *
 * @returns {{type: *}}
 */
export const open = () => ({ type: OPEN_MODAL });

/**
 *
 * @returns {{type: *}}
 */
export const close = () => ({ type: CLOSE_MODAL });
